import { useState } from "react";
import { FirstAid, Pill, BeerStein, ShieldCheck, Binoculars, ForkKnife, House, MagnifyingGlass, MapPin, ArrowSquareOut, Heart } from "@phosphor-icons/react";

export const PLACES = [
  ["restaurants", "Restaurants", ForkKnife, "restaurants"],
  ["hospital", "Hospital", FirstAid, "hospital"],
  ["pharmacy", "Pharmacy", Pill, "pharmacy"],
  ["bars", "Bars", BeerStein, "bars"],
  ["police", "Police", ShieldCheck, "police station"],
  ["attractions", "Attractions", Binoculars, "tourist attractions"],
];

const search = (q, address) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address ? `${q} near ${address}` : `${q} near me`)}`;
const placeLink = (p, address) => (/^https?:\/\//i.test(p.map_url || "") ? p.map_url : search(p.name, address));
export const homeLink = (info) => (info?.address ? `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(info.address)}&travelmode=driving` : info?.map_url || "");

function Picks({ cat, pins, address }) {
  const [, label, , q] = cat;
  return (
    <div className="rise mt-3 rounded-2xl p-3" style={{ background: "var(--t-bg)" }} data-testid={`explore-picks-${cat[0]}`}>
      <p className="flex items-center gap-1.5 px-1 text-xs font-semibold uppercase tracking-wider" style={{ color: "var(--t-primary)" }}><Heart size={12} weight="fill" /> Host's picks · {label}</p>
      <div className="mt-1 divide-y" style={{ borderColor: "var(--t-border)" }}>
        {pins.map((p, i) => (
          <a key={i} href={placeLink(p, address)} target="_blank" rel="noreferrer" data-testid={`explore-pick-${cat[0]}-${i}`} className="flex items-center gap-3 px-1 py-2.5">
            <MapPin size={18} style={{ color: "var(--t-primary)" }} className="shrink-0" />
            <span className="min-w-0 flex-1"><span className="block font-medium" style={{ color: "var(--t-text)" }}>{p.name}</span>{p.note && <span className="block text-xs" style={{ color: "var(--t-muted)" }}>{p.note}</span>}</span>
            <ArrowSquareOut size={16} style={{ color: "var(--t-muted)" }} />
          </a>
        ))}
      </div>
      <a href={search(q, address)} target="_blank" rel="noreferrer" data-testid={`explore-more-${cat[0]}`} className="mt-1 block px-1 py-1.5 text-sm font-semibold" style={{ color: "var(--t-primary)" }}>See more on Google Maps</a>
    </div>
  );
}

export function Explore({ info }) {
  const [open, setOpen] = useState(null);
  const address = info?.address;
  const pinsFor = (k) => (info?.nearby || []).filter((n) => n.category === k && n.name);
  const tap = (e, k) => { if (pinsFor(k).length) { e.preventDefault(); setOpen(open === k ? null : k); } };
  const cat = PLACES.find((c) => c[0] === open);
  return (
    <section className="rounded-3xl border p-5" style={{ background: "var(--t-card)", borderColor: "var(--t-border)" }} data-testid="guest-explore-card">
      <div className="mb-3 flex items-center gap-2">
        <span className="grid h-9 w-9 place-items-center rounded-full" style={{ background: "var(--t-soft)", color: "var(--t-primary)" }}><MagnifyingGlass size={18} weight="bold" /></span>
        <div><h4 className="text-lg font-medium" style={{ color: "var(--t-text)" }}>Find nearby</h4><p className="text-xs" style={{ color: "var(--t-muted)" }}>Opens Google Maps {address ? "around the stay" : "around you"}</p></div>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {PLACES.map(([k, label, Icon, q]) => {
          const n = pinsFor(k).length;
          return (
            <a key={k} href={search(q, address)} onClick={(e) => tap(e, k)} target="_blank" rel="noreferrer" data-testid={`explore-${k}-button`}
              className="relative flex flex-col items-center gap-1.5 rounded-2xl px-2 py-3 text-xs font-semibold transition-transform duration-200 active:scale-95"
              style={{ background: open === k ? "var(--t-soft)" : "var(--t-bg)", color: "var(--t-text)" }}>
              {n > 0 && <span className="absolute right-1.5 top-1.5 grid h-4 min-w-4 place-items-center rounded-full px-1 text-[10px]" style={{ background: "var(--t-primary)", color: "var(--t-on-primary)" }} data-testid={`explore-${k}-count`}>{n}</span>}
              <Icon size={22} style={{ color: "var(--t-primary)" }} /> {label}
            </a>
          );
        })}
      </div>
      {cat && <Picks cat={cat} pins={pinsFor(open)} address={address} />}
    </section>
  );
}

export function TakeHome({ info }) {
  const href = homeLink(info);
  if (!href) return null;
  return (
    <div className="sticky bottom-4 z-20 flex justify-center pt-2" data-testid="take-home-wrap">
      <a href={href} target="_blank" rel="noreferrer" data-testid="take-home-button"
        className="inline-flex h-14 items-center gap-2 rounded-full px-7 text-base font-bold uppercase tracking-wider shadow-xl transition-transform duration-200 active:scale-95"
        style={{ background: "var(--t-primary)", color: "var(--t-on-primary)" }}>
        <House size={22} weight="fill" /> Take me home
      </a>
    </div>
  );
}
